import react from "react";
import RegisterScreen from "../../screens/Register/RegisterScreen";

const RegisterContainer = () => {
  return <RegisterScreen />;
};

export default RegisterContainer;
